import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "react-toastify";
import { topCoinDistributionCardService } from "../services/topCoinDistributionCardService";
import { MdOutlinePictureAsPdf } from "react-icons/md";

function TopCoinDistributionQrModal({ card, onClose }) {
  const [downloading, setDownloading] = useState(false);

  if (!card) return null;

  const handleCopyUrl = () => {
    if (card.qr_code_data) {
      navigator.clipboard.writeText(card.qr_code_data);
      toast.success("Redemption URL copied to clipboard!");
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPdf = async () => {
    try {
      setDownloading(true);
      await topCoinDistributionCardService.downloadSingleCardQrPdf(card.id, card.card_number);
      toast.success("Card PDF downloaded successfully!");
    } catch (error) {
      console.error("Failed to download PDF:", error);
      toast.error("Failed to download card PDF");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "50%",
                backgroundColor: card.card_color || "#A7ADB4",
                border: "2px solid #fff",
                boxShadow: "0 0 4px rgba(0,0,0,0.2)",
              }}
            />
            <h3 style={{ margin: 0, color: "#111827", fontSize: "18px" }}>
              TopCoin Card QR Code
            </h3>
          </div>
          <button onClick={onClose} style={closeBtnStyle}>
            ✕
          </button>
        </div>

        <div style={cardPreviewStyle(card.card_color)}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
            <span style={{ fontWeight: 800, fontSize: "14px", letterSpacing: "1px", color: "#1f2937" }}>
              TOPCOIN UK
            </span>
            <span
              style={{
                backgroundColor: card.card_color || "#A7ADB4",
                color: "#fff",
                padding: "3px 10px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: 700,
                textTransform: "uppercase",
                boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
              }}
            >
              {card.card_tier || "Tier"}
            </span>
          </div>

          <div style={{ display: "flex", justifyContent: "center", padding: "16px", backgroundColor: "#fff", borderRadius: "10px", boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)" }}>
            <QRCodeSVG
              value={card.qr_code_data || `${card.card_number}:${card.serial_number}`}
              size={180}
              level="H"
              includeMargin={true}
            />
          </div>

          <div style={{ marginTop: "14px", textAlign: "center" }}>
            <div style={{ fontSize: "20px", fontWeight: 800, color: "#0f172a", marginBottom: "4px" }}>
              {card.top_coin_value} TopCoin{Number(card.top_coin_value) === 1 ? "" : "s"}
            </div>
            <div style={{ fontSize: "13px", color: "#475569", fontWeight: 600 }}>
              Card No: <span style={{ fontFamily: "monospace", color: "#0f172a" }}>{card.card_number}</span>
            </div>
            <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>
              Serial: <span style={{ fontFamily: "monospace", letterSpacing: "1px" }}>{card.serial_number}</span>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "15px", display: "flex", flexDirection: "column", gap: "8px" }}>
          {/* <div style={{ fontSize: "12px", color: "#6b7280", wordBreak: "break-all", backgroundColor: "#f3f4f6", padding: "8px", borderRadius: "6px", fontFamily: "monospace" }}>
            <strong>URL:</strong> {card.qr_code_data}
          </div> */}

          <div style={{ display: "flex", justifyContent: "right", marginTop: "10px", gap: "10px" }}>
            {/* <button onClick={handleCopyUrl} style={btnSecondary}>
              Copy URL
            </button> */}
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                type="button"
                onClick={handleDownloadPdf}
                disabled={downloading}
                title="Download QR Code Card as PDF"
                style={{
                  ...btnSecondary,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  backgroundColor: "#0284c7",
                  color: "#ffffff",
                  borderColor: "#0369a1",
                  cursor: downloading ? "wait" : "pointer",
                  opacity: downloading ? 0.75 : 1,
                }}
              >
                <MdOutlinePictureAsPdf size={16} />
                <span>{downloading ? "Downloading..." : "Download PDF"}</span>
              </button>
              <button onClick={handlePrint} style={btnSecondary}>
                Print Card
              </button>
              <button onClick={onClose} style={btnPrimary}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1100,
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "24px",
  borderRadius: "12px",
  width: "380px",
  maxWidth: "92%",
  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.2)",
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "16px",
};

const closeBtnStyle = {
  background: "none",
  border: "none",
  fontSize: "18px",
  cursor: "pointer",
  color: "#9ca3af",
};

const cardPreviewStyle = (color) => ({
  backgroundColor: "#f8fafc",
  border: `2px solid ${color || "#e2e8f0"}`,
  borderRadius: "12px",
  padding: "16px",
  position: "relative",
  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
});

const btnBase = {
  padding: "8px 16px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "13px",
  fontWeight: 600,
};

const btnPrimary = {
  ...btnBase,
  backgroundColor: "#1e3a8a",
  color: "#fff",
};

const btnSecondary = {
  ...btnBase,
  backgroundColor: "#f1f5f9",
  color: "#334155",
  border: "1px solid #cbd5e1",
};

export default TopCoinDistributionQrModal;
